var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 257,
    viewBox: "0 0 375 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373 2.00041C373 2.00041 202.743 1.99949 136.909 2.00041C110.395 2.00078 59.8945 17.8143 37.4808 39.9503C6.56857 70.4797 -0.130865 99.8145 2.53087 141.15C5.80048 191.926 72.4307 255 72.4307 255H166.795C166.795 255 114.372 183.844 103.886 141.15C98.5778 119.54 103.884 93.7128 124.856 77.9003C145.827 62.0878 258.327 62.0878 258.327 62.0878H373V2.00041Z",
    fill: "#B8C7FF",
    stroke: "#B8C7FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.90b9773d8b8b8d839a8cc236de17119b.svg";
export { ForwardRef as ReactComponent };